import script from "./AddMemberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMemberModal.vue?vue&type=script&setup=true&lang=js"

import "./AddMemberModal.vue?vue&type=style&index=0&id=e0c6df22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0c6df22"]])

export default __exports__